<template>
  <footer>
    <div class="tachyon-container tachyon-footer">
      <router-link to="/">
        <img src="/static/img/footer_logo.png" alt="logo">
      </router-link>
      <nav class="footer-menu">
        <ul>
          <li>
            <p>Tachyon is a product owned by Empire Digital Media Ltd (trading as 1Digit)</p>          
          </li>
          <!-- <li>
            <router-link to="/">Terms Use</router-link>
          </li>
          <li>
            <router-link to="/">Privacy Policy</router-link>
          </li>
          <li>
            <router-link to="/">Cookies Policy</router-link>
          </li>
          <li>
            <router-link to="/">Support</router-link>
          </li> -->
        </ul>
      </nav>
      <small class="copyright">2019 Copyright - Tachyon<br>All Rights Reserved</small>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style scoped>
  .tachyon-footer {
    font-family: 'RubicRegular', sans-serif;
    font-weight: 400;
    line-height: 23px;
    padding-top: 50px;
    padding-bottom: 50px;
    margin-top: -150px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tachyon-footer img {
    margin-top: -10px;
  }
  .footer-menu li {
    display: inline-block;
    margin: 0 40px;
  }
  .footer-menu a {
    color: #838383;
    font-size: 19px;
  }
  .copyright {
    color: #a9a9a9;
    font-size: 12px;
    margin-left: 10%;
  }
  @media (max-width: 1300px) {
    .footer-menu li {
      margin: 0 20px;
    }
  }
  @media (max-width: 1199px) {
    .copyright {
      margin-left: 0;
    }
  }
  @media (max-width: 991px) {
    .tachyon-footer {
      padding-bottom: 30px;
      margin-top: -300px;
      flex-direction: column;
    }
    .footer-menu {
      padding: 30px 0 10px;
    }
    .footer-menu li {
      margin-bottom: 20px;
    }
    .copyright {
      text-align: center;
    }
  }
  @media (max-width: 767px) {
    .footer-menu {
      width: 100%;
      max-width: 430px;
      margin-left: 10%;
    }
    .footer-menu li {
      width: 40%;
    }
  }
  @media (max-width: 479px) {
    .footer-menu {
      max-width: 300px;
      margin-left: 0;
    }
    .footer-menu li:nth-child(odd) {
      width: 47%;
    }
    .footer-menu li:nth-child(even) {
      width: 37%;
    }
    .footer-menu li {
      margin-left: 10px;
      margin-right: 10px;
    }
    .footer-menu a {
      font-size: 15px;
      line-height: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue